/**
 * Table time formatting
 */
export function formatDate(cellValue) {
  if (cellValue == null || cellValue == "") return "";
  var date = new Date(cellValue);
  var year = date.getFullYear();
  var month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var minutes =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var seconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return (
    year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
  );
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "just";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "Minutes ago";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "Hours ago";
  } else if (diff < 3600 * 24 * 2) {
    return "1 day ago";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "month" +
      d.getDate() +
      "day" +
      d.getHours() +
      "hour" +
      d.getMinutes() +
      "minute"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    //According to the last trigger interval
    const last = +new Date() - timestamp;

    //The last call interval of the wrapped function last is less than the set interval wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      //If it is set to immediate = = = true, because the start boundary has been called, there is no need to call here
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    //If the delay does not exist, reset the delay
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

export function splitK(num, int, noFh) {
  if (num || num === 0) {
    num = Number(num).toFixed(2);
    let fh = "";
    num = String(num);
    if (num.indexOf("-") > -1) {
      fh = "-";
      num = num.slice(1);
    }
    let decimal = String(num).split(".")[1] || "00";
    let tempArr = [];
    let revNumArr = String(num)
      .split(".")[0]
      .split("")
      .reverse();
    for (let i in revNumArr) {
      tempArr.push(revNumArr[i]);
      if ((i + 1) % 3 === 0 && i != revNumArr.length - 1) {
        tempArr.push(",");
      }
    }
    let zs = tempArr.reverse().join("");
    if (!int)
      return decimal
        ? (noFh ? "" : fh) + zs + "." + decimal
        : (noFh ? "" : fh) + zs;
    if (int) return (noFh ? "" : fh) + zs;
  }
  return "0.00";
}
export function fileDownload(blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(new Blob([blob]), fileName);
  } else {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([blob]));
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
}

export function conver(byte, unit, noUnit, onlyUnit) {
  //Byte: value, unit: the unit of the value itself, nounit: No unit is required for the return value, onlyunit: only unit is returned
  if (unit == "MB" || unit == "M") {
    byte = byte * 1024 * 1024;
  } else if (unit == "GB" || unit == "G") {
    byte = byte * 1024 * 1024 * 1024;
  }
  let size = "",
    after = "";
  if (byte < 0.1 * 1024) {
    size = byte.toFixed(2);
    after = " B";
  } else if (byte < 0.1 * 1024 * 1024) {
    size = (byte / 1024).toFixed(2);
    after = " K";
  } else if (byte < 0.1 * 1024 * 1024 * 1024) {
    size = (byte / (1024 * 1024)).toFixed(2);
    after = " M";
  } else if (byte < 0.1 * 1024 * 1024 * 1024 * 1024) {
    size = (byte / (1024 * 1024 * 1024)).toFixed(2);
    after = " G";
  } else if (byte < 0.1 * 1024 * 1024 * 1024 * 1024 * 1024) {
    size = (byte / (1024 * 1024 * 1024 * 1024)).toFixed(2);
    after = " T";
  }
  size = size.replace(".00", "");
  if (onlyUnit) {
    return after;
  }
  return size + (noUnit ? "" : after);
}

export function scrollAnimate(list) {
  list = ["scrollId1", "scrollId2", "scrollId3", "scrollId4"];
  var domHight = document.body.offsetHeight;
  var scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  var id;
  var scrollHeight;
  var offsetTop;
  var top;
  var bottom;
  list.map(i => {
    id = document.getElementById(i);
    scrollHeight = id.scrollHeight;
    offsetTop = id.offsetTop;
    top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
    bottom = scrollHeight + offsetTop;
    if (scrollTop >= top && scrollTop <= bottom) {
      id.style.animation = "showLeft 1s forwards";
    } else {
      id.style.animation = "hideLeft 0s forwards"; //隐藏动画
    }
  });
  window.addEventListener("scroll", scrollAnimate);
}

export function isIntNum(val) {
  var regPos = /^[0-9]+.?[0-9]*/; //判断是否是数字。
  var regNeg = /^\-[1-9][0-9]*$/; // 负整数
  if (regPos.test(val) && !regNeg.test(val)) {
    return true;
  } else {
    return false;
  }
}
